export default {
  label: "Asma Ul Husna",
  items: [
    { key: "all", label: "Sab" },
    { key: "rehmat", label: "Rehmat" },
    { key: "qudrat", label: "Qudrat" },
    { key: "ilm", label: "Ilm" },
    { key: "rizq", label: "Rizq" },
    { key: "adal", label: "Adal" },
    { key: "hifazat", label: "Hifazat" },
    { key: "khalq", label: "Khalq" },
    { key: "zindagi", label: "Zindagi" },
    { key: "azmat", label: "Azmat" },
  ],
};
